// Mirrors Finkit.Permissions.HostPagesPermissions.FinkitHostPagesPermissions
// .TraderSurveillanceTemplates (GroupName = "HostPages").
export const TsTemplatePermissions = {
  view: 'HostPages.TraderSurveillanceTemplates',
  create: 'HostPages.TraderSurveillanceTemplates.Create',
  edit: 'HostPages.TraderSurveillanceTemplates.Edit',
  delete: 'HostPages.TraderSurveillanceTemplates.Delete',
} as const;
